export default __webpack_public_path__ + "static/media/left_bottom_image_desktop.4c12bfda.png";